import { useEffect } from 'react';
import i18n, { addModuleTranslations } from '../utils/i18n';

function useLangInit(module) {
  useEffect(() => {
    module = module || "common";
    if (i18n.language && module) {
      addModuleTranslations({module: module});
    }
    const langhandler = (lng) => {
      // console.log(lng);
      if (i18n.language && module) {
        addModuleTranslations({module: module});
      }
    };
    i18n.on('languageChanged', langhandler);
    return () => {
      i18n.off('languageChanged', langhandler);
    };
  }, [module]);
}

export default useLangInit;
